// react core
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';

import InlineAnswer from 'components/answers/inline_answer';
import AjaxSpinner from 'components/commons/ajax_spinner';
import Reply from 'components/answers/reply';
import QuestionExpanded from './question_expanded';
import InlinePost from 'components/answers/inline_post';
// utils
import { clone_object } from 'commons/utils';
import { send_images, i_have_viewed_that, put_ids_in_question_viewed } from 'commons/api';
import usePageTitle from 'commons/page_title';
// conf
import conf from 'conf/ajax';
// api
import {get_question_and_its_data_by_id} from 'commons/api';

const read_data = (_id) =>
{
    return new Promise((resolve, reject) =>
    {
        fetch(conf.plone_site + conf.server.answer.replace('{id}', _id),
            conf.ajax_configuration_object)
            .then(res => res.json())
            .then(
                (result) =>
                {
                    resolve(result);
                },
                (error) =>
                {
                    reject(error);
                }
            ).catch(err =>
            {
                reject(err);
            });
    });
}
/*
export function get_data_for_question_by_id({ request, params })
{
    return get_question_and_data_by_id(params.id);
    //return get_question_and_data_by_id()
}
*/
export default function QuestionAndAnswers(prpos)
{
    const [force_refrsh_counter, set_force_refrsh_counter] = useState(0);
    const navigate = useNavigate();
    const [is_sending, set_is_sending] = useState(null);
    const [res, set_response] = useState({});
    const questionTitle = res?.parent?.title || 'Q&A';
    usePageTitle(questionTitle);
    const form_ref = useRef(null);
    let params = useParams();

    useEffect(() =>
    {
        let mounted = true;
        const fetchData = async () =>
        {
            const response =  await get_question_and_its_data_by_id(params.id);
            if(response.status !== 404)
            {
                const data = await response.json();
                if (mounted)
                {
                    const viewed = await i_have_viewed_that(params.id);
                    if(viewed === null) { console.log('already visited'); }
                    if(viewed && viewed.ok)
                    {
                        console.log('viewed');
                        put_ids_in_question_viewed(params.id);
                    }
                    set_response(data);
                }
            }
            else
            {
                navigate(conf.route.page_not_found);
            }
        }
        // call the function
        fetchData()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [params.id, navigate, force_refrsh_counter]);

    const refresh_page = () =>
    {
        //navigate(0);
        let tmp = force_refrsh_counter;
        tmp = tmp + 1;
        set_force_refrsh_counter(tmp);
    }

    const on_write_btn = (evt) =>
    {
        form_ref.current.scrollIntoView();
    };

    let on_send = (obj) =>
    {
        // clone object to avoid global overwrite
        let data_obj = clone_object(conf.ajax_configuration_object);
        const image_set = clone_object(obj.image_set);
        const blob_set = clone_object(obj.blob_set);
        delete obj.image_set;
        delete obj.blob_set;
        const files_array = image_set.concat(blob_set);
        data_obj.method = 'POST';
        data_obj.body = JSON.stringify(obj);
        set_is_sending(true);
        fetch(conf.endpoints.insertpost, data_obj).then(function (response)
        {
            return response.json();
        }).then(function (data)
        {
            if (data.status === 'ok' && data.id !== null)
            {
                const last_cb = () =>
                {
                    NotificationManager.success('Your answer has been added', 'Thank you!');
                    set_is_sending(false);
                    read_data(params.id).then(data =>
                    {
                        // refresh page?
                        setTimeout(() =>
                        {
                            refresh_page();
                        }, 500);
                    });
                }
                if(files_array.length > 0)
                {
                    // reply created, sending pictures...
                    const post_image_url = `${params.id}/${data.id}`;
                    send_images(files_array, post_image_url).then(() =>
                    {
                        last_cb();
                    });
                }
                else
                {
                    // no images to send...
                    last_cb();
                }
            }
            else
            {
                NotificationManager.error('Error: unable to create content', 'Oops...', 5000, () => {});
            }
        }).catch(error => console.error('Error:', error));
    };

    useEffect(() =>
    {
        document.body.classList.add('question-page');
        return () =>
        {
            document.body.classList.remove('question-page');
        };
    });

    const handle_on_comment_post = (evt) =>
    {
        refresh_page();
    };

    const handle_approve_post = (evt) =>
    {
        refresh_page();
    };


    if (is_sending)
    {
        return <AjaxSpinner />;
    }
    else
    {
        const currentQuestion = res;
        const parent_id = currentQuestion.parent?.id || 'none';
        return (
            <>
                <QuestionExpanded
                    item={currentQuestion.parent}
                    on_comment_post={handle_on_comment_post}
                    on_write_btn={on_write_btn}
                />


                <div className='comments-wrapper'>
                {(currentQuestion.comments?.length > 0) && <h3>{(currentQuestion.comments.length > 1) ? 'Comments' : 'Comment'}</h3>}
                {currentQuestion.comments?.map(item =>
                (
                    <InlinePost
                        key={item.id}
                        item={item}
                        type="comment"
                        on_comment_post={handle_on_comment_post}
                        on_approve_post={handle_approve_post}
                        can_comment={item.can_comment}
                    />
                ))}
                </div>

                <div className='answers-wrapper'>
                {(currentQuestion.answers?.length > 0) && <h2><i className='fa-solid fa-reply'></i> {(currentQuestion.answers.length > 1) ? 'Answers' : 'Answer'}</h2>}
                {currentQuestion.answers?.map(item =>
                (
                    <InlineAnswer
                        show_vote={true}
                        key={item.id}
                        item={item}
                        on_comment_post={handle_on_comment_post}
                        on_approve_post={handle_approve_post}
                        can_comment={item.can_comment}
                        can_answer={item.can_answer}
                    />
                ))}
                </div>
                {currentQuestion?.parent?.can_answer &&
                <div ref={form_ref} className='add-answer-wrapper'>
                    <h2>Write your answer</h2>
                    <Reply
                        type="reply"
                        parent_type="question"
                        pid={parent_id}
                        button_text="Post your answer"
                        onSend={on_send}
                        placeholder="Insert the text here..."
                    />
                </div>}
            </>
        );
    }
}
